import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {DownloadIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

const reportImage = require("../images/report.png");

export const PropertyDetailVendorReportSection = () => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const onClick = () => {
        if (isUserAuthenticated) {
            //TODO vendor raport download.
            // It is probably worth adding an optional function (onSuccess: () => void;) to the modal state that will perform the download after logging in/registering.
            // Related task RP-27 Możliwość pobrania raportu o deweloperze
            console.log("Tu będzie pobranie raportu dla zalogowanego użytkownika");
        } else {
            dispatch(
                openAuthModal({
                    // TODO UserSource to fix in/after RP-30 Możliwość pobrania raportu o deweloperze [Analityka]
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    modalVariant: "download_raport",
                    headerVariant: AuthModalVariant.DOWNLOAD_RAPORT
                })
            );
        }
    };

    return (
        <div className={sectionWrapper}>
            <Image width="210px" height="204px" alt="" src={reportImage} className={imageStyle} />

            <div className={textWrapper}>
                <Text variant="headline_4" as="p" mb={1.5} align={isMobile ? "center" : "start"}>
                    Raport o deweloperze
                </Text>
                <Text variant="body_copy_1" mb={1.5} align={isMobile ? "center" : "start"}>
                    Poznaj dewelopera bliżej! Pobierz raport, w którym znajdziesz kluczowe informacje o firmie, jej doświadczeniu, nagrodach oraz aktualnych i
                    zrealizowanych inwestycjach.
                </Text>

                <Button variant="filled_primary" size="medium" iconLeft={DownloadIcon} className={buttonStyle} onClick={onClick}>
                    Pobierz raport
                </Button>
            </div>
        </div>
    );
};

const sectionWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#FFF",
    p: 2,
    mb: 2,
    borderRadius: 2,
    gap: 2,

    md: {
        flexDirection: "row",
        alignItems: "start",
        p: 3,
        mb: 3,
        gap: 4
    }
});

const textWrapper = css({
    textAlign: "center",

    md: {
        textAlign: "start"
    }
});

const imageStyle = css({
    minWidth: "210px"
});

const buttonStyle = css({
    minWidth: "200px",
    mt: 1.5,

    md: {
        mt: 0
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {DownloadIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/store/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

const reportImage = require("../images/report.png");

export const PropertyDetailVendorReportSection = () => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const onClick = () => {
        if (isUserAuthenticated) {
            //TODO vendor raport download.
            // It is probably worth adding an optional function (onSuccess: () => void;) to the modal state that will perform the download after logging in/registering.
            // Related task RP-27 Możliwość pobrania raportu o deweloperze
            console.log("Tu będzie pobranie raportu dla zalogowanego użytkownika");
        } else {
            dispatch(
                openAuthModal({
                    // TODO UserSource to fix in/after RP-30 Możliwość pobrania raportu o deweloperze [Analityka]
                    userSource: UserSource.REGISTER_PROPERTY_PLAN,
                    modalVariant: "download_raport",
                    headerVariant: AuthModalVariant.DOWNLOAD_RAPORT
                })
            );
        }
    };

    return (
        <div className={sectionWrapper}>
            <Image width="210px" height="204px" alt="" src={reportImage} className={imageStyle} />

            <div className={textWrapper}>
                <Text variant="headline_4" as="p" mb={1.5} align={isMobile ? "center" : "start"}>
                    Raport o deweloperze
                </Text>
                <Text variant="body_copy_1" mb={1.5} align={isMobile ? "center" : "start"}>
                    Poznaj dewelopera bliżej! Pobierz raport, w którym znajdziesz kluczowe informacje o firmie, jej doświadczeniu, nagrodach oraz aktualnych i
                    zrealizowanych inwestycjach.
                </Text>

                <Button variant="filled_primary" size="medium" iconLeft={DownloadIcon} className={buttonStyle} onClick={onClick}>
                    Pobierz raport
                </Button>
            </div>
        </div>
    );
};

const sectionWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#FFF",
    p: 2,
    mb: 2,
    borderRadius: 2,
    gap: 2,

    md: {
        flexDirection: "row",
        alignItems: "start",
        p: 3,
        mb: 3,
        gap: 4
    }
});

const textWrapper = css({
    textAlign: "center",

    md: {
        textAlign: "start"
    }
});

const imageStyle = css({
    minWidth: "210px"
});

const buttonStyle = css({
    minWidth: "200px",
    mt: 1.5,

    md: {
        mt: 0
    }
});
